import React from 'react';
import {cn} from '@/utils';
import {
  RechargeWebBonusRibbon,
  type RechargeWebAmountGridRow,
} from '@fe-progressive/package-progressive/recharge-web';

type Props = {
  rows: readonly RechargeWebAmountGridRow[];
  selectedId?: number;
  onSelect: (row: RechargeWebAmountGridRow) => void;
  currencySymbol: string;
  formatAmount: (amount: number) => string;
  getBonusLabel?: (row: RechargeWebAmountGridRow) => string | undefined;
  className?: string;
  isWeekCard?: boolean;
};

export function RechargeAmountGridById({
  rows,
  selectedId,
  onSelect,
  currencySymbol,
  formatAmount,
  getBonusLabel,
  className,
  isWeekCard = false,
}: Props) {
  return (
    <div
      className={cn('grid w-full grid-cols-4 gap-x-2 gap-y-3 pt-2', className)}>
      {rows.map((row, index) => {
        const selected = row.id != null && row.id === selectedId;
        const bonus = getBonusLabel?.(row);
        return (
          <div key={row.id ?? index} className="relative flex flex-col">
            <RechargeWebBonusRibbon label={bonus ?? ''} />
            <button
              type="button"
              aria-pressed={selected}
              onClick={() => onSelect(row)}
              className={cn(
                'relative flex h-[2.5rem] w-full min-w-px items-center justify-center overflow-hidden rounded-[0.25rem] p-2 text-center font-bold transition-all',
                isWeekCard ? 'text-[0.75rem]' : 'text-[0.875rem]',
                selected
                  ? 'border border-solid border-[rgba(255,255,255,0.1)] bg-c1 text-white'
                  : 'border border-solid border-[rgba(255,255,255,0.5)] bg-gradient-to-b from-[#f2f4f9] to-[#f3f5fb] text-black shadow-[0_0.125rem_0_0_#c3c8dc]',
              )}>
              {row.chipPrimaryLabel != null && row.chipPrimaryLabel !== ''
                ? row.chipPrimaryLabel
                : `${currencySymbol}${formatAmount(row.balance)}`}
            </button>
          </div>
        );
      })}
    </div>
  );
}
